import React from 'react';

const Title = () => {
    return(
        <div className="title">
            <h2>Practice your Hiragana/Katakana!</h2>
            <br/>
            <h2>ひらがなとカタカナを練習する</h2>
        </div>
    );
}

export default Title;